import o from "./SVGs/addToFolder.svg.mjs";
import r from "./SVGs/addedtoFolder.svg.mjs";
import t from "./SVGs/aiWand.svg.mjs";
import e from "./SVGs/alarmBell.svg.mjs";
import i from "./SVGs/alignBottom.svg.mjs";
import n from "./SVGs/alignCenter.svg.mjs";
import l from "./SVGs/alignLeft.svg.mjs";
import m from "./SVGs/alignMiddle.svg.mjs";
import a from "./SVGs/alignRight.svg.mjs";
import c from "./SVGs/alignTop.svg.mjs";
import s from "./SVGs/amex.svg.mjs";
import p from "./SVGs/applePay.svg.mjs";
import g from "./SVGs/arrowBack.svg.mjs";
import S from "./SVGs/arrowCursor_blue.svg.mjs";
import f from "./SVGs/arrowCursor_pink.svg.mjs";
import v from "./SVGs/arrowCursor_yellow.svg.mjs";
import u from "./SVGs/arrowDown.svg.mjs";
import d from "./SVGs/arrowRight.svg.mjs";
import w from "./SVGs/arrowUp.svg.mjs";
import k from "./SVGs/attachment.svg.mjs";
import P from "./SVGs/audioModified.svg.mjs";
import B from "./SVGs/blankCalendar_blue.svg.mjs";
import C from "./SVGs/blankCalendar_pink.svg.mjs";
import h from "./SVGs/blankCalendar_yellow.svg.mjs";
import Y from "./SVGs/brain.svg.mjs";
import y from "./SVGs/businessStartup_blue.svg.mjs";
import A from "./SVGs/businessStartup_pink.svg.mjs";
import b from "./SVGs/businessStartup_yellow.svg.mjs";
import M from "./SVGs/calendar.svg.mjs";
import I from "./SVGs/cameraVideo_blue.svg.mjs";
import V from "./SVGs/cameraVideo_pink.svg.mjs";
import L from "./SVGs/cameraVideo_yellow.svg.mjs";
import T from "./SVGs/camera_blue.svg.mjs";
import F from "./SVGs/camera_pink.svg.mjs";
import H from "./SVGs/camera_yellow.svg.mjs";
import G from "./SVGs/chatBubbleTypingOval_blue.svg.mjs";
import E from "./SVGs/chatBubbleTypingOval_pink.svg.mjs";
import U from "./SVGs/chatBubbleTypingOval_yellow.svg.mjs";
import W from "./SVGs/chatTwoBubblesSquare_blue.svg.mjs";
import D from "./SVGs/chatTwoBubblesSquare_pink.svg.mjs";
import O from "./SVGs/chatTwoBubblesSquare_yellow.svg.mjs";
import R from "./SVGs/check.svg.mjs";
import x from "./SVGs/checkCircle.svg.mjs";
import q from "./SVGs/chevronDown.svg.mjs";
import N from "./SVGs/chevronLeft.svg.mjs";
import K from "./SVGs/chevronRight.svg.mjs";
import z from "./SVGs/chevronUp.svg.mjs";
import Q from "./SVGs/circleCheck.svg.mjs";
import Z from "./SVGs/circleClock_black.svg.mjs";
import j from "./SVGs/circleClock_blue.svg.mjs";
import J from "./SVGs/circleClock_pink.svg.mjs";
import X from "./SVGs/circleClock_yellow.svg.mjs";
import _ from "./SVGs/close.svg.mjs";
import $ from "./SVGs/cog.svg.mjs";
import oo from "./SVGs/compass.svg.mjs";
import ro from "./SVGs/controlsForward.svg.mjs";
import to from "./SVGs/controlsPause.svg.mjs";
import eo from "./SVGs/controlsPlay.svg.mjs";
import io from "./SVGs/controlsRecord.svg.mjs";
import no from "./SVGs/controlsRewind.svg.mjs";
import lo from "./SVGs/controlsStop.svg.mjs";
import mo from "./SVGs/dashboardGauge_blue.svg.mjs";
import ao from "./SVGs/dashboardGauge_pink.svg.mjs";
import co from "./SVGs/dashboardGauge_yellow.svg.mjs";
import so from "./SVGs/dinersClub.svg.mjs";
import po from "./SVGs/discover.svg.mjs";
import go from "./SVGs/downloadBottom.svg.mjs";
import So from "./SVGs/downloadSquare_blue.svg.mjs";
import fo from "./SVGs/downloadSquare_pink.svg.mjs";
import vo from "./SVGs/downloadSquare_yellow.svg.mjs";
import uo from "./SVGs/dropbox.svg.mjs";
import wo from "./SVGs/emptyClipboard_blue.svg.mjs";
import ko from "./SVGs/emptyClipboard_pink.svg.mjs";
import Po from "./SVGs/emptyClipboard_yellow.svg.mjs";
import Bo from "./SVGs/erlenmeyerFlask_blue.svg.mjs";
import Co from "./SVGs/erlenmeyerFlask_pink.svg.mjs";
import ho from "./SVGs/erlenmeyerFlask_yellow.svg.mjs";
import Yo from "./SVGs/error.svg.mjs";
import yo from "./SVGs/expandHorizontal.svg.mjs";
import Ao from "./SVGs/expandVertical.svg.mjs";
import bo from "./SVGs/facebook.svg.mjs";
import Mo from "./SVGs/favorite.svg.mjs";
import Io from "./SVGs/favoriteFilled.svg.mjs";
import Vo from "./SVGs/fileDouble.svg.mjs";
import Lo from "./SVGs/filter.svg.mjs";
import To from "./SVGs/filterImage.svg.mjs";
import Fo from "./SVGs/filterMusic.svg.mjs";
import Ho from "./SVGs/filterPlus.svg.mjs";
import Go from "./SVGs/filterVideo.svg.mjs";
import Eo from "./SVGs/folderStar.svg.mjs";
import Uo from "./SVGs/generateImage.svg.mjs";
import Wo from "./SVGs/generateVideo.svg.mjs";
import Do from "./SVGs/gitHub.svg.mjs";
import Oo from "./SVGs/googlePay.svg.mjs";
import Ro from "./SVGs/graphPieChart_blue.svg.mjs";
import xo from "./SVGs/graphPieChart_pink.svg.mjs";
import qo from "./SVGs/graphPieChart_yellow.svg.mjs";
import No from "./SVGs/gridRules_blue.svg.mjs";
import Ko from "./SVGs/gridRules_pink.svg.mjs";
import zo from "./SVGs/gridRules_yellow.svg.mjs";
import Qo from "./SVGs/happyFace_blue.svg.mjs";
import Zo from "./SVGs/happyFace_pink.svg.mjs";
import jo from "./SVGs/happyFace_yellow.svg.mjs";
import Jo from "./SVGs/headphonesCustomer.svg.mjs";
import Xo from "./SVGs/helpChat_blue.svg.mjs";
import _o from "./SVGs/helpChat_pink.svg.mjs";
import $o from "./SVGs/helpChat_yellow.svg.mjs";
import or from "./SVGs/home_blue.svg.mjs";
import rr from "./SVGs/home_pink.svg.mjs";
import tr from "./SVGs/home_yellow.svg.mjs";
import er from "./SVGs/hourGlass_blue.svg.mjs";
import ir from "./SVGs/hourGlass_pink.svg.mjs";
import nr from "./SVGs/hourGlass_yellow.svg.mjs";
import lr from "./SVGs/house.svg.mjs";
import mr from "./SVGs/image.svg.mjs";
import ar from "./SVGs/imageModified.svg.mjs";
import cr from "./SVGs/informationCircle.svg.mjs";
import sr from "./SVGs/informationCircleInverted.svg.mjs";
import pr from "./SVGs/instagram.svg.mjs";
import gr from "./SVGs/interfaceAlertAlarmBell_blue.svg.mjs";
import Sr from "./SVGs/interfaceAlertAlarmBell_pink.svg.mjs";
import fr from "./SVGs/interfaceAlertAlarmBell_yellow.svg.mjs";
import vr from "./SVGs/interfaceAwardTrophy_blue.svg.mjs";
import ur from "./SVGs/interfaceAwardTrophy_pink.svg.mjs";
import dr from "./SVGs/interfaceAwardTrophy_yellow.svg.mjs";
import wr from "./SVGs/interfaceCursorArrow_blue.svg.mjs";
import kr from "./SVGs/interfaceCursorArrow_pink.svg.mjs";
import Pr from "./SVGs/interfaceCursorArrow_yellow.svg.mjs";
import Br from "./SVGs/interfaceFavoriteLike_blue.svg.mjs";
import Cr from "./SVGs/interfaceFavoriteLike_pink.svg.mjs";
import hr from "./SVGs/interfaceFavoriteLike_yellow.svg.mjs";
import Yr from "./SVGs/interfaceImageVideoAudioSubtitles_blue.svg.mjs";
import yr from "./SVGs/interfaceImageVideoAudioSubtitles_pink.svg.mjs";
import Ar from "./SVGs/interfaceImageVideoAudioSubtitles_yellow.svg.mjs";
import br from "./SVGs/interfaceLightingLightBulb_blue.svg.mjs";
import Mr from "./SVGs/interfaceLightingLightBulb_pink.svg.mjs";
import Ir from "./SVGs/interfaceLightingLightBulb_yellow.svg.mjs";
import Vr from "./SVGs/interfaceSearch_blue.svg.mjs";
import Lr from "./SVGs/interfaceSearch_pink.svg.mjs";
import Tr from "./SVGs/interfaceSearch_yellow.svg.mjs";
import Fr from "./SVGs/keyboardArrowRight.svg.mjs";
import Hr from "./SVGs/keyboard_blue.svg.mjs";
import Gr from "./SVGs/keyboard_pink.svg.mjs";
import Er from "./SVGs/keyboard_yellow.svg.mjs";
import Ur from "./SVGs/layers_blue.svg.mjs";
import Wr from "./SVGs/layers_pink.svg.mjs";
import Dr from "./SVGs/layers_yellow.svg.mjs";
import Or from "./SVGs/layoutWindow_blue.svg.mjs";
import Rr from "./SVGs/layoutWindow_pink.svg.mjs";
import xr from "./SVGs/layoutWindow_yellow.svg.mjs";
import qr from "./SVGs/linkedIn.svg.mjs";
import Nr from "./SVGs/loadingRing.svg.mjs";
import Kr from "./SVGs/lock.svg.mjs";
import zr from "./SVGs/lockUnlock.svg.mjs";
import Qr from "./SVGs/login_blue.svg.mjs";
import Zr from "./SVGs/login_pink.svg.mjs";
import jr from "./SVGs/login_yellow.svg.mjs";
import Jr from "./SVGs/logoStoryblocks.svg.mjs";
import Xr from "./SVGs/logoStoryblocksGray.svg.mjs";
import _r from "./SVGs/logoStoryblocksWhite.svg.mjs";
import $r from "./SVGs/maestro.svg.mjs";
import ot from "./SVGs/magicWand_blue.svg.mjs";
import rt from "./SVGs/magicWand_pink.svg.mjs";
import tt from "./SVGs/magicWand_yellow.svg.mjs";
import et from "./SVGs/maker.svg.mjs";
import it from "./SVGs/mastercard.svg.mjs";
import nt from "./SVGs/meetingCamera.svg.mjs";
import lt from "./SVGs/megaphone_blue.svg.mjs";
import mt from "./SVGs/megaphone_pink.svg.mjs";
import at from "./SVGs/megaphone_yellow.svg.mjs";
import ct from "./SVGs/microphone.svg.mjs";
import st from "./SVGs/microphoneOff.svg.mjs";
import pt from "./SVGs/moneyCashBill_blue.svg.mjs";
import gt from "./SVGs/moneyCashBill_pink.svg.mjs";
import St from "./SVGs/moneyCashBill_yellow.svg.mjs";
import ft from "./SVGs/moneyWallet_blue.svg.mjs";
import vt from "./SVGs/moneyWallet_pink.svg.mjs";
import ut from "./SVGs/moneyWallet_yellow.svg.mjs";
import dt from "./SVGs/musicSound.svg.mjs";
import wt from "./SVGs/navigationMenuHorizontal.svg.mjs";
import kt from "./SVGs/navigationMenuVertical.svg.mjs";
import Pt from "./SVGs/newStickyNote_blue.svg.mjs";
import Bt from "./SVGs/newStickyNote_pink.svg.mjs";
import Ct from "./SVGs/newStickyNote_yellow.svg.mjs";
import ht from "./SVGs/oneFingerTap_blue.svg.mjs";
import Yt from "./SVGs/oneFingerTap_pink.svg.mjs";
import yt from "./SVGs/oneFingerTap_yellow.svg.mjs";
import At from "./SVGs/openBook_blue.svg.mjs";
import bt from "./SVGs/openBook_pink.svg.mjs";
import Mt from "./SVGs/openBook_yellow.svg.mjs";
import It from "./SVGs/panelCollapse.svg.mjs";
import Vt from "./SVGs/panelExpand.svg.mjs";
import Lt from "./SVGs/paragraphLeftAlign.svg.mjs";
import Tt from "./SVGs/paragraphsCenterAlign.svg.mjs";
import Ft from "./SVGs/paragraphsRightAlign.svg.mjs";
import Ht from "./SVGs/payPal.svg.mjs";
import Gt from "./SVGs/pen_blue.svg.mjs";
import Et from "./SVGs/pen_pink.svg.mjs";
import Ut from "./SVGs/pen_yellow.svg.mjs";
import Wt from "./SVGs/pencil.svg.mjs";
import Dt from "./SVGs/picturesFolderMemories_blue.svg.mjs";
import Ot from "./SVGs/picturesFolderMemories_pink.svg.mjs";
import Rt from "./SVGs/picturesFolderMemories_yellow.svg.mjs";
import xt from "./SVGs/pin_blue.svg.mjs";
import qt from "./SVGs/pin_pink.svg.mjs";
import Nt from "./SVGs/pin_yellow.svg.mjs";
import Kt from "./SVGs/pinterest.svg.mjs";
import zt from "./SVGs/playList_blue.svg.mjs";
import Qt from "./SVGs/playList_pink.svg.mjs";
import Zt from "./SVGs/playList_yellow.svg.mjs";
import jt from "./SVGs/playVideo.svg.mjs";
import Jt from "./SVGs/plus.svg.mjs";
import Xt from "./SVGs/profileAvatar.svg.mjs";
import _t from "./SVGs/questionmark.svg.mjs";
import $t from "./SVGs/refresh.svg.mjs";
import oe from "./SVGs/screenTv_blue.svg.mjs";
import re from "./SVGs/screenTv_pink.svg.mjs";
import te from "./SVGs/screenTv_yellow.svg.mjs";
import ee from "./SVGs/script_blue.svg.mjs";
import ie from "./SVGs/script_pink.svg.mjs";
import ne from "./SVGs/script_yellow.svg.mjs";
import le from "./SVGs/search.svg.mjs";
import me from "./SVGs/searchSimilar.svg.mjs";
import ae from "./SVGs/settingMenu.svg.mjs";
import ce from "./SVGs/share.svg.mjs";
import se from "./SVGs/shoppingCart_blue.svg.mjs";
import pe from "./SVGs/shoppingCart_pink.svg.mjs";
import ge from "./SVGs/shoppingCart_yellow.svg.mjs";
import Se from "./SVGs/snapchat.svg.mjs";
import fe from "./SVGs/sparkle.svg.mjs";
import ve from "./SVGs/sparkles.svg.mjs";
import ue from "./SVGs/stamp.svg.mjs";
import de from "./SVGs/starFourSided.svg.mjs";
import we from "./SVGs/stopwatch_blue.svg.mjs";
import ke from "./SVGs/stopwatch_pink.svg.mjs";
import Pe from "./SVGs/stopwatch_yellow.svg.mjs";
import Be from "./SVGs/stripe.svg.mjs";
import Ce from "./SVGs/sunCloud_blue.svg.mjs";
import he from "./SVGs/sunCloud_pink.svg.mjs";
import Ye from "./SVGs/sunCloud_yellow.svg.mjs";
import ye from "./SVGs/textBold.svg.mjs";
import Ae from "./SVGs/textInputArea.svg.mjs";
import be from "./SVGs/textItalic.svg.mjs";
import Me from "./SVGs/textStrikeThrough.svg.mjs";
import Ie from "./SVGs/textStyle.svg.mjs";
import Ve from "./SVGs/textUnderline.svg.mjs";
import Le from "./SVGs/thirdEye.svg.mjs";
import Te from "./SVGs/thumbDown.svg.mjs";
import Fe from "./SVGs/thumbUp.svg.mjs";
import He from "./SVGs/trash.svg.mjs";
import Ge from "./SVGs/travelMapEarth_blue.svg.mjs";
import Ee from "./SVGs/travelMapEarth_pink.svg.mjs";
import Ue from "./SVGs/travelMapEarth_yellow.svg.mjs";
import We from "./SVGs/twitter.svg.mjs";
import De from "./SVGs/uploadBottom.svg.mjs";
import Oe from "./SVGs/uploadCircle_blue.svg.mjs";
import Re from "./SVGs/uploadCircle_pink.svg.mjs";
import xe from "./SVGs/uploadCircle_yellow.svg.mjs";
import qe from "./SVGs/userCircleSingle_blue.svg.mjs";
import Ne from "./SVGs/userCircleSingle_pink.svg.mjs";
import Ke from "./SVGs/userCircleSingle_yellow.svg.mjs";
import ze from "./SVGs/userSingle_blue.svg.mjs";
import Qe from "./SVGs/userSingle_pink.svg.mjs";
import Ze from "./SVGs/userSingle_yellow.svg.mjs";
import je from "./SVGs/venmo.svg.mjs";
import Je from "./SVGs/verticalSliderSquare_blue.svg.mjs";
import Xe from "./SVGs/verticalSliderSquare_pink.svg.mjs";
import _e from "./SVGs/verticalSliderSquare_yellow.svg.mjs";
import $e from "./SVGs/videoEditPeel.svg.mjs";
import oi from "./SVGs/videoEditSplit.svg.mjs";
import ri from "./SVGs/videoModified.svg.mjs";
import ti from "./SVGs/videoPlayerAlternate.svg.mjs";
import ei from "./SVGs/view.svg.mjs";
import ii from "./SVGs/viewOff.svg.mjs";
import ni from "./SVGs/visa.svg.mjs";
import li from "./SVGs/voiceMail_blue.svg.mjs";
import mi from "./SVGs/voiceMail_pink.svg.mjs";
import ai from "./SVGs/voiceMail_yellow.svg.mjs";
import ci from "./SVGs/volumeDown.svg.mjs";
import si from "./SVGs/volumeLevelHigh_blue.svg.mjs";
import pi from "./SVGs/volumeLevelHigh_pink.svg.mjs";
import gi from "./SVGs/volumeLevelHigh_yellow.svg.mjs";
import Si from "./SVGs/volumeMedium.svg.mjs";
import fi from "./SVGs/volumeOff.svg.mjs";
import vi from "./SVGs/volumeUp.svg.mjs";
import ui from "./SVGs/warningTriangle.svg.mjs";
import di from "./SVGs/waveform.svg.mjs";
import wi from "./SVGs/webcamVideo_blue.svg.mjs";
import ki from "./SVGs/webcamVideo_pink.svg.mjs";
import Pi from "./SVGs/webcamVideo_yellow.svg.mjs";
import Bi from "./SVGs/youtube.svg.mjs";
import Ci from "./SVGs/zap.svg.mjs";
const zc = o, Qc = r, Zc = t, jc = e, Jc = i, Xc = n, _c = l, $c = m, os = a, rs = c, ts = s, es = p, is = g, ns = S, ls = f, ms = v, as = u, cs = d, ss = w, ps = k, gs = P, Ss = B, fs = C, vs = h, us = Y, ds = y, ws = A, ks = b, Ps = M, Bs = T, Cs = F, hs = H, Ys = I, ys = V, As = L, bs = G, Ms = E, Is = U, Vs = W, Ls = D, Ts = O, Fs = R, Hs = x, Gs = q, Es = N, Us = K, Ws = z, Ds = Q, Os = Z, Rs = j, xs = J, qs = X, Ns = _, Ks = $, zs = oo, Qs = ro, Zs = to, js = eo, Js = io, Xs = no, _s = lo, $s = mo, op = ao, rp = co, tp = so, ep = po, ip = go, np = So, lp = fo, mp = vo, ap = uo, cp = wo, sp = ko, pp = Po, gp = Bo, Sp = Co, fp = ho, vp = Yo, up = yo, dp = Ao, wp = bo, kp = Mo, Pp = Io, Bp = Vo, Cp = Lo, hp = To, Yp = Fo, yp = Ho, Ap = Go, bp = Eo, Mp = Uo, Ip = Wo, Vp = Do, Lp = Oo, Tp = Ro, Fp = xo, Hp = qo, Gp = No, Ep = Ko, Up = zo, Wp = Qo, Dp = Zo, Op = jo, Rp = Jo, xp = Xo, qp = _o, Np = $o, Kp = or, zp = rr, Qp = tr, Zp = er, jp = ir, Jp = nr, Xp = lr, _p = mr, $p = ar, og = cr, rg = sr, tg = pr, eg = gr, ig = Sr, ng = fr, lg = vr, mg = ur, ag = dr, cg = wr, sg = kr, pg = Pr, gg = Br, Sg = Cr, fg = hr, vg = Yr, ug = yr, dg = Ar, wg = br, kg = Mr, Pg = Ir, Bg = Vr, Cg = Lr, hg = Tr, Yg = Hr, yg = Gr, Ag = Er, bg = Fr, Mg = Ur, Ig = Wr, Vg = Dr, Lg = Or, Tg = Rr, Fg = xr, Hg = qr, Gg = Nr, Eg = Kr, Ug = zr, Wg = Qr, Dg = Zr, Og = jr, Rg = Jr, xg = Xr, qg = _r, Ng = $r, Kg = ot, zg = rt, Qg = tt, Zg = et, jg = it, Jg = nt, Xg = lt, _g = mt, $g = at, oS = ct, rS = st, tS = pt, eS = gt, iS = St, nS = ft, lS = vt, mS = ut, aS = dt, cS = wt, sS = kt, pS = Pt, gS = Bt, SS = Ct, fS = ht, vS = Yt, uS = yt, dS = At, wS = bt, kS = Mt, PS = It, BS = Vt, CS = Lt, hS = Tt, YS = Ft, yS = Ht, AS = Gt, bS = Et, MS = Ut, IS = Wt, VS = Dt, LS = Ot, TS = Rt, FS = xt, HS = qt, GS = Nt, ES = Kt, US = zt, WS = Qt, DS = Zt, OS = jt, RS = Jt, xS = Xt, qS = _t, NS = $t, KS = oe, zS = re, QS = te, ZS = ee, jS = ie, JS = ne, XS = le, _S = me, $S = ae, of = ce, rf = se, tf = pe, ef = ge, nf = Se, lf = fe, mf = ve, af = ue, cf = de, sf = we, pf = ke, gf = Pe, Sf = Be, ff = Ce, vf = he, uf = Ye, df = ye, wf = Ae, kf = be, Pf = Me, Bf = Ie, Cf = Ve, hf = Le, Yf = Te, yf = Fe, Af = He, bf = Ge, Mf = Ee, If = Ue, Vf = We, Lf = De, Tf = Oe, Ff = Re, Hf = xe, Gf = qe, Ef = Ne, Uf = Ke, Wf = ze, Df = Qe, Of = Ze, Rf = je, xf = Je, qf = Xe, Nf = _e, Kf = $e, zf = oi, Qf = ri, Zf = ti, jf = ei, Jf = ii, Xf = ni, _f = li, $f = mi, ov = ai, rv = ci, tv = si, ev = pi, iv = gi, nv = Si, lv = fi, mv = vi, av = ui, cv = di, sv = wi, pv = ki, gv = Pi, Sv = Bi, fv = Ci;
export {
  zc as AddToFolder,
  Qc as AddedtoFolder,
  Zc as AiWand,
  jc as AlarmBell,
  Jc as AlignBottom,
  Xc as AlignCenter,
  _c as AlignLeft,
  $c as AlignMiddle,
  os as AlignRight,
  rs as AlignTop,
  ts as Amex,
  es as ApplePay,
  is as ArrowBack,
  ns as ArrowCursorBlue,
  ls as ArrowCursorPink,
  ms as ArrowCursorYellow,
  as as ArrowDown,
  cs as ArrowRight,
  ss as ArrowUp,
  ps as Attachment,
  gs as AudioModified,
  Ss as BlankCalendarBlue,
  fs as BlankCalendarPink,
  vs as BlankCalendarYellow,
  us as Brain,
  ds as BusinessStartupBlue,
  ws as BusinessStartupPink,
  ks as BusinessStartupYellow,
  Ps as Calendar,
  Bs as CameraBlue,
  Cs as CameraPink,
  Ys as CameraVideoBlue,
  ys as CameraVideoPink,
  As as CameraVideoYellow,
  hs as CameraYellow,
  bs as ChatBubbleTypingOvalBlue,
  Ms as ChatBubbleTypingOvalPink,
  Is as ChatBubbleTypingOvalYellow,
  Vs as ChatTwoBubblesSquareBlue,
  Ls as ChatTwoBubblesSquarePink,
  Ts as ChatTwoBubblesSquareYellow,
  Fs as Check,
  Hs as CheckCircle,
  Gs as ChevronDown,
  Es as ChevronLeft,
  Us as ChevronRight,
  Ws as ChevronUp,
  Ds as CircleCheck,
  Os as CircleClockBlack,
  Rs as CircleClockBlue,
  xs as CircleClockPink,
  qs as CircleClockYellow,
  Ns as Close,
  Ks as Cog,
  zs as Compass,
  Qs as ControlsForward,
  Zs as ControlsPause,
  js as ControlsPlay,
  Js as ControlsRecord,
  Xs as ControlsRewind,
  _s as ControlsStop,
  $s as DashboardGaugeBlue,
  op as DashboardGaugePink,
  rp as DashboardGaugeYellow,
  tp as DinersClub,
  ep as Discover,
  ip as DownloadBottom,
  np as DownloadSquareBlue,
  lp as DownloadSquarePink,
  mp as DownloadSquareYellow,
  ap as Dropbox,
  cp as EmptyClipboardBlue,
  sp as EmptyClipboardPink,
  pp as EmptyClipboardYellow,
  gp as ErlenmeyerFlaskBlue,
  Sp as ErlenmeyerFlaskPink,
  fp as ErlenmeyerFlaskYellow,
  vp as Error,
  up as ExpandHorizontal,
  dp as ExpandVertical,
  wp as Facebook,
  kp as Favorite,
  Pp as FavoriteFilled,
  Bp as FileDouble,
  Cp as Filter,
  hp as FilterImage,
  Yp as FilterMusic,
  yp as FilterPlus,
  Ap as FilterVideo,
  bp as FolderStar,
  Mp as GenerateImage,
  Ip as GenerateVideo,
  Vp as GitHub,
  Lp as GooglePay,
  Tp as GraphPieChartBlue,
  Fp as GraphPieChartPink,
  Hp as GraphPieChartYellow,
  Gp as GridRulesBlue,
  Ep as GridRulesPink,
  Up as GridRulesYellow,
  Wp as HappyFaceBlue,
  Dp as HappyFacePink,
  Op as HappyFaceYellow,
  Rp as HeadphonesCustomer,
  xp as HelpChatBlue,
  qp as HelpChatPink,
  Np as HelpChatYellow,
  Kp as HomeBlue,
  zp as HomePink,
  Qp as HomeYellow,
  Zp as HourGlassBlue,
  jp as HourGlassPink,
  Jp as HourGlassYellow,
  Xp as House,
  _p as Image,
  $p as ImageModified,
  og as InformationCircle,
  rg as InformationCircleInverted,
  tg as Instagram,
  eg as InterfaceAlertAlarmBellBlue,
  ig as InterfaceAlertAlarmBellPink,
  ng as InterfaceAlertAlarmBellYellow,
  lg as InterfaceAwardTrophyBlue,
  mg as InterfaceAwardTrophyPink,
  ag as InterfaceAwardTrophyYellow,
  cg as InterfaceCursorArrowBlue,
  sg as InterfaceCursorArrowPink,
  pg as InterfaceCursorArrowYellow,
  gg as InterfaceFavoriteLikeBlue,
  Sg as InterfaceFavoriteLikePink,
  fg as InterfaceFavoriteLikeYellow,
  vg as InterfaceImageVideoAudioSubtitlesBlue,
  ug as InterfaceImageVideoAudioSubtitlesPink,
  dg as InterfaceImageVideoAudioSubtitlesYellow,
  wg as InterfaceLightingLightBulbBlue,
  kg as InterfaceLightingLightBulbPink,
  Pg as InterfaceLightingLightBulbYellow,
  Bg as InterfaceSearchBlue,
  Cg as InterfaceSearchPink,
  hg as InterfaceSearchYellow,
  bg as KeyboardArrowRight,
  Yg as KeyboardBlue,
  yg as KeyboardPink,
  Ag as KeyboardYellow,
  Mg as LayersBlue,
  Ig as LayersPink,
  Vg as LayersYellow,
  Lg as LayoutWindowBlue,
  Tg as LayoutWindowPink,
  Fg as LayoutWindowYellow,
  Hg as LinkedIn,
  Gg as LoadingRing,
  Eg as Lock,
  Ug as LockUnlock,
  Wg as LoginBlue,
  Dg as LoginPink,
  Og as LoginYellow,
  Rg as LogoStoryblocks,
  xg as LogoStoryblocksGray,
  qg as LogoStoryblocksWhite,
  Ng as Maestro,
  Kg as MagicWandBlue,
  zg as MagicWandPink,
  Qg as MagicWandYellow,
  Zg as Maker,
  jg as Mastercard,
  Jg as MeetingCamera,
  Xg as MegaphoneBlue,
  _g as MegaphonePink,
  $g as MegaphoneYellow,
  oS as Microphone,
  rS as MicrophoneOff,
  tS as MoneyCashBillBlue,
  eS as MoneyCashBillPink,
  iS as MoneyCashBillYellow,
  nS as MoneyWalletBlue,
  lS as MoneyWalletPink,
  mS as MoneyWalletYellow,
  aS as MusicSound,
  cS as NavigationMenuHorizontal,
  sS as NavigationMenuVertical,
  pS as NewStickyNoteBlue,
  gS as NewStickyNotePink,
  SS as NewStickyNoteYellow,
  fS as OneFingerTapBlue,
  vS as OneFingerTapPink,
  uS as OneFingerTapYellow,
  dS as OpenBookBlue,
  wS as OpenBookPink,
  kS as OpenBookYellow,
  PS as PanelCollapse,
  BS as PanelExpand,
  CS as ParagraphLeftAlign,
  hS as ParagraphsCenterAlign,
  YS as ParagraphsRightAlign,
  yS as PayPal,
  AS as PenBlue,
  bS as PenPink,
  MS as PenYellow,
  IS as Pencil,
  VS as PicturesFolderMemoriesBlue,
  LS as PicturesFolderMemoriesPink,
  TS as PicturesFolderMemoriesYellow,
  FS as PinBlue,
  HS as PinPink,
  GS as PinYellow,
  ES as Pinterest,
  US as PlayListBlue,
  WS as PlayListPink,
  DS as PlayListYellow,
  OS as PlayVideo,
  RS as Plus,
  xS as ProfileAvatar,
  qS as Questionmark,
  NS as Refresh,
  KS as ScreenTvBlue,
  zS as ScreenTvPink,
  QS as ScreenTvYellow,
  ZS as ScriptBlue,
  jS as ScriptPink,
  JS as ScriptYellow,
  XS as Search,
  _S as SearchSimilar,
  $S as SettingMenu,
  of as Share,
  rf as ShoppingCartBlue,
  tf as ShoppingCartPink,
  ef as ShoppingCartYellow,
  nf as Snapchat,
  lf as Sparkle,
  mf as Sparkles,
  af as Stamp,
  cf as StarFourSided,
  sf as StopwatchBlue,
  pf as StopwatchPink,
  gf as StopwatchYellow,
  Sf as Stripe,
  ff as SunCloudBlue,
  vf as SunCloudPink,
  uf as SunCloudYellow,
  df as TextBold,
  wf as TextInputArea,
  kf as TextItalic,
  Pf as TextStrikeThrough,
  Bf as TextStyle,
  Cf as TextUnderline,
  hf as ThirdEye,
  Yf as ThumbDown,
  yf as ThumbUp,
  Af as Trash,
  bf as TravelMapEarthBlue,
  Mf as TravelMapEarthPink,
  If as TravelMapEarthYellow,
  Vf as Twitter,
  Lf as UploadBottom,
  Tf as UploadCircleBlue,
  Ff as UploadCirclePink,
  Hf as UploadCircleYellow,
  Gf as UserCircleSingleBlue,
  Ef as UserCircleSinglePink,
  Uf as UserCircleSingleYellow,
  Wf as UserSingleBlue,
  Df as UserSinglePink,
  Of as UserSingleYellow,
  Rf as Venmo,
  xf as VerticalSliderSquareBlue,
  qf as VerticalSliderSquarePink,
  Nf as VerticalSliderSquareYellow,
  Kf as VideoEditPeel,
  zf as VideoEditSplit,
  Qf as VideoModified,
  Zf as VideoPlayerAlternate,
  jf as View,
  Jf as ViewOff,
  Xf as Visa,
  _f as VoiceMailBlue,
  $f as VoiceMailPink,
  ov as VoiceMailYellow,
  rv as VolumeDown,
  tv as VolumeLevelHighBlue,
  ev as VolumeLevelHighPink,
  iv as VolumeLevelHighYellow,
  nv as VolumeMedium,
  lv as VolumeOff,
  mv as VolumeUp,
  av as WarningTriangle,
  cv as Waveform,
  sv as WebcamVideoBlue,
  pv as WebcamVideoPink,
  gv as WebcamVideoYellow,
  Sv as Youtube,
  fv as Zap
};
